import { Box, Typography } from "@mui/material";

type AssetsCountCellProps = {
  value: number | null | undefined;
};

export function AssetsCountCell({ value }: AssetsCountCellProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          fontSize: "14px",
        }}
      >
        {value ?? "-"}
      </Typography>
    </Box>
  );
}
